var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('show-welcome'),_c('div',{staticClass:"container"},[_c('show-popular',{attrs:{"tests":_vm.tests}}),_c('show-advert')],1),_c('show-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }